import React, { Component } from "react";

export default class Team extends Component {
  render() {
    return (
      <section className="section-team parallax">
        <div className="row">
          <div className="text-box-bg-image">
            <h1>
              WITH SMILEFISH WE WERE ABLE TO NOT ONLY GROW OUR AUDIENCE, BUT
              ENGAGE AND TRACK FOR BETTER CONNECTION AND CONVERSION - LUKE S
            </h1>
          </div>
        </div>
      </section>
    );
  }
}
